/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Editor from 'cio/components/action-composer/base/editor';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { classNames } from '@ember-decorators/component';
import { MIN_LIMIT, MAX_LIMIT } from 'cio/components/action-composer/types/collection-query';
import { IdentifierKey } from 'cio/utils/identifiers';
import { CREATED_IN_CIO_AT } from 'cio/utils/attributes';

const DEFAULT_QUERY_RESULT_SIZE = 10;

@classNames('action-composer-panel', 'action-composer-panel--editor')
export default class CollectionQueryEditor extends Editor {
  @service environment;
  @service store;

  // external
  collections = [];
  isPreviewLoading = false;
  setCollection() {}

  // internal
  selectedResultLimitOption = null;
  minLimit = MIN_LIMIT;
  maxLimit = MAX_LIMIT;

  get action() {
    return this.editableEntity.action;
  }

  get conditionTypes() {
    return ['collection_attribute'];
  }

  get resultLimitOptions() {
    return [
      { label: 'Limit to one result', value: 'single' },
      { label: 'Limit to a specific number', value: 'limited' },
    ];
  }

  get validCollections() {
    return this.collections.filter((collection) => {
      return !collection.importing && !collection.importIsInvalid;
    });
  }

  @computed('action.collection.schema.[]')
  get collectionSchemaItems() {
    let options = [{ label: 'Do not sort', value: undefined }];
    let schema = this.action.get('collection.schema');
    return schema ? [...options, ...schema.map((value) => ({ label: value, value }))] : options;
  }

  @computed('environment.sentAttributes')
  get availableAttributes() {
    return this.environment.sentAttributes.filter((attr) => ![IdentifierKey.CioId, CREATED_IN_CIO_AT].includes(attr));
  }

  setInitialLimitOption(action) {
    let selectedResultLimitOption = 'limited';

    if (action.singleResult) {
      selectedResultLimitOption = 'single';
    }

    this.setProperties({ selectedResultLimitOption });
  }

  didInsertElement() {
    super.didInsertElement(...arguments);
    this.setInitialLimitOption(this.action);
  }

  @action
  setLimitOption({ value }) {
    if (value === 'single') {
      this.action.setProperties({
        singleResult: true,
        limit: undefined,
      });
    } else {
      this.action.setProperties({
        singleResult: false,
        limit: this.action.limit ?? DEFAULT_QUERY_RESULT_SIZE,
      });
    }

    this.set('selectedResultLimitOption', value);
  }

  @action
  setProfileAttribute(selection) {
    return this.action.set('attributeName', selection);
  }
}
